(() => {
  const boot = () => {
    const meta = window.OakridgeProductMeta;
    if (!meta || !meta.variants?.length) return;
    const normalize = (value) => String(value || '').trim().toLowerCase();
    const colorIndex = (meta.optionNames || []).findIndex((name) => normalize(name) === 'color');

    const getMediaItems = () => Array.from(document.querySelectorAll('[data-media-id]')).filter((el) => el.querySelector('img'));
    const findMediaItem = (mediaId) => getMediaItems().find((el) => {
      const id = String(el.getAttribute('data-media-id') || '');
      return id === String(mediaId) || id.endsWith(String(mediaId));
    });

    const getSelectedOptions = () => {
      const values = [];
      const optionNames = meta.optionNames || [];
      optionNames.forEach((name) => {
        const normalizedName = normalize(name);
        const radios = Array.from(document.querySelectorAll('input[type="radio"]')).filter((input) => {
          const inputName = normalize(input.name);
          if (inputName === normalizedName || inputName === `options[${normalizedName}]`) return true;
          const fieldset = input.closest('fieldset');
          return !!fieldset && normalize(fieldset.querySelector('legend')?.textContent) === normalizedName;
        });
        const checked = radios.find((input) => input.checked);
        if (checked) { values.push(String(checked.value)); return; }
        const select = Array.from(document.querySelectorAll('select')).find((el) => {
          const n = normalize(el.name || el.id);
          return n === normalizedName || n === `options[${normalizedName}]`;
        });
        values.push(select?.value || '');
      });
      return values;
    };

    const findVariantForSelection = (selectedOptions) => {
      const normalized = selectedOptions.map(normalize);
      const exact = meta.variants.find((variant) => {
        const options = (variant.options || []).map(normalize);
        return options.length === normalized.length && options.every((value, index) => value === normalized[index]) && variant.mediaId;
      });
      if (exact) return exact;

      // Color must always resolve to a real color image even if the selected size
      // does not have its own media association. Fall back to the first variant
      // of the selected color that has a featured media image.
      if (colorIndex >= 0 && normalized[colorIndex]) {
        return meta.variants.find((variant) => {
          const options = (variant.options || []).map(normalize);
          return normalize(options[colorIndex]) === normalized[colorIndex] && variant.mediaId;
        });
      }
      return null;
    };

    const goToVariantMedia = (variant) => {
      if (!variant?.mediaId) return;
      const target = findMediaItem(variant.mediaId);
      if (!target) return;
      const clickable = target.closest('button, a') || target;
      if (clickable && typeof clickable.click === 'function') clickable.click();
      target.setAttribute('data-oakridge-variant-focus', variant.id || '');
    };

    const refresh = () => {
      const selected = getSelectedOptions();
      if (selected.some((value) => !value)) return;
      const variant = findVariantForSelection(selected);
      if (variant) requestAnimationFrame(() => goToVariantMedia(variant));
    };

    document.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement) setTimeout(refresh, 50);
    }, true);
    ['variant:change', 'theme:variants:changed'].forEach((eventName) => {
      document.addEventListener(eventName, () => setTimeout(refresh, 50));
    });
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();